import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component, ViewEncapsulation, inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ViewConfig, ViewModes } from '@spartacus/storefront';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormulaBlueService } from 'src/app/services/feature/Formula_blue/formula-blue.service';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { SteeringGearService } from 'src/app/services/feature/steeringGear/steering-gear.service';

@Component({
  selector: 'app-formula-blue',
  templateUrl: './formula-blue.component.html',
  styleUrls: ['./formula-blue.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FormulaBlueComponent {
  ApiData: any;

  subscription = new Subscription();
  kbformulaBlueService = inject(FormulaBlueService);
  kbTempService = inject(ProductListService);
  productListService = inject(ProductListService);
  viewportScroller = inject(ViewportScroller);
  scrollConfig = inject(ViewConfig);
  cdr = inject(ChangeDetectorRef);

  productTypes$: Observable<any>;
  year$: Observable<any>;
  make$: Observable<any>;
  model$: Observable<any>;

  isInfiniteScroll: boolean | undefined;
  defaultPageSize: any = 10;

  productModel: any;
  viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  ViewModes = ViewModes;

  //Method to initialize the form
  formulaBlueForm = new FormGroup({
    ProductType: new FormControl(null, { validators: Validators.required }),
    Year: new FormControl(null, { validators: Validators.required }),
    Make: new FormControl(null, { validators: Validators.required }),
    Model: new FormControl(null, { validators: Validators.required }),

  });
  isMobile: boolean;
  bottomSectionPDP: boolean;

  get form() {
    return this.formulaBlueForm.controls;
  }

  constructor(
    public breakpointObserver: BreakpointObserver,
    private cd: ChangeDetectorRef
  ) {
    this.subscription.add(this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.setViewMode(this.ViewModes.Grid);
        }
        else {
          this.setViewMode(this.ViewModes.List);
        }
      }));
  }

  ngOnInit() {
    this.isInfiniteScroll = this.scrollConfig.view?.infiniteScroll?.active;

    this.productTypes$ = this.kbformulaBlueService.getProdDetails().pipe(
      map(ProdData => {
        const transformedData = Object.keys(ProdData).map(key => ({
          key: key,
          value: ProdData[key].replace(/_/g, ' ')
        }));
        this.cd.detectChanges();
        return transformedData;
      })
    );
    this.subscription.add(this.formulaBlueForm.get('ProductType').valueChanges.subscribe(ProductType => {
      this.year$ = this.kbformulaBlueService.getYearDetails(ProductType).pipe(
        map(yearData => {
          return Object.keys(yearData).map(key => ({ key: key, value: yearData[key] }))
            .sort((a, b) => b.key.localeCompare(a.key));
        })
      );
    }));

    this.subscription.add(this.formulaBlueForm.get('Year').valueChanges.subscribe(year => {
      this.make$ = this.kbformulaBlueService.getMakeDetails(this.formulaBlueForm.value.ProductType, year).pipe(
        map(makeData => {
          return Object.keys(makeData).map(key => ({ key: key, value: makeData[key] }));
        })
      );

    }));

    this.subscription.add(this.formulaBlueForm.get('Make').valueChanges.subscribe(make => {
      this.model$ = this.kbformulaBlueService.getModelDetails(this.formulaBlueForm.value.ProductType, this.formulaBlueForm.value.Year, make).pipe(
        map(modelData => {
          return Object.keys(modelData).map(key => ({ key: key, value: modelData[key] }));
        })
      );

    }));
  }

  formulaBlueFormreset() {
    this.bottomSectionPDP = false;
    this.formulaBlueForm.reset();
  }

  search(currentPage: any, pageSize: any, sort: string, model: any) {
    const pagination = {
      currentPage: currentPage,
      pageSize: pageSize,
      sort: sort,
    };

    this.subscription.add(this.productListService
      .getCustomDocDetails(
        this.defaultPageSize,
        this.productListService.DecodeQuery('000'),
        0,
      )
      .subscribe((data) => {
        this.productListService.seperateDocDetails$.next(data);
        this.productListService.selectedTabIndex.next(7);
        this.cdr.detectChanges();
      }));
  }
  changePageSize(pageSize: any, model: any) {
    this.defaultPageSize = pageSize;
    this.search(model.pagination.currentPage, Number(pageSize), model.pagination.sort, model);
  }
  changePage(page: number, model: any) {
    this.search(page, model.pagination.pageSize, model.pagination.sort, model);
  }
  sortList(e, model) {
    this.subscription.add(this.productListService
      .getCustomDocDetails(
        this.defaultPageSize,
        this.productListService.DecodeQuery(model.currentQuery.query.value),
        model.pagination.currentPage,
        e
      )
      .subscribe((data) => {
        this.productListService.seperateDocDetails$.next(data);

      }));
  }
  changePageCustom(currentPage, model, type) {
    this.viewportScroller.scrollToPosition([0, 200]);
    const query = this.productListService.DecodeQuery(model.currentQuery?.query.value);
    if (type == 2) {
      this.subscription.add(this.productListService
        .getDocumentDetails(this.defaultPageSize, query, currentPage, model.pagination.sort)
        .subscribe((data) => {

        }));
    } else if (type === 3) {
      this.subscription.add(this.productListService
        .getSoftwareDetails(this.defaultPageSize, query, currentPage, model.pagination.sort)
        .subscribe((data) => {

        }));
    }
  }

  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode);
  }

  onSubmit(): void {
    if (this.formulaBlueForm.valid) {

      const payLoadFormat =
      {
        productType: this.form.ProductType.value,
        year: this.form.Year.value,
        make: this.form.Make.value,
        modelz: this.form.Model.value
      };
      this.kbformulaBlueService.formulaBluePayLoad$.next(payLoadFormat);

      this.subscription.add(this.kbformulaBlueService.submitFormulaData(payLoadFormat, 10, '', 0, '').subscribe(data => {
        this.productListService.FormulaProdDetails$.next(data?.['searchPageData']);
        this.productListService.selectedTabIndex.next(10);
        this.bottomSectionPDP = true;
        this.cdr.detectChanges();
      }));
    }
  }
  ngOnDestroy() {
    this.productListService.selectedTabIndex.next(0);
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();


  }
}
